export const colors = {
  green: 'hsl(174, 29.361702127659573%, 46.07843137254902%)',
  greenLight: 'hsl(174, 25.581395348837212%, 57.843137254901954%)',
  greenMid: 'hsl(174, 30.5%, 46.07843137254902%)',
  greenDark: 'hsl(174, 32%, 37.05882352941177%)',
  gold: 'hsl(35, 68.30601092896174%, 64.11764705882352%)',
  goldLight: 'hsl(35, 78.41726618705036%, 72.74509803921568%)',
  goldMid: 'hsl(35, 60.19417475728157%, 59.6078431372549%)',
  goldDark: 'hsl(34, 51.69491525423729%, 46.27450980392157%)',
  gray98: 'hsl(300, 2%, 98%)',
  gray95: 'hsl(300, 2%, 95%)',
  gray90: 'hsl(300, 2%, 90%)',
  gray85: 'hsl(300, 2%, 85%)',
  gray75: 'hsl(300, 3%, 75%)',
  gray65: 'hsl(300, 3%, 65%)',
  gray45: 'hsl(300, 3.5%, 45%)',
  gray30: 'hsl(300, 4%, 30%)',
  gray20: 'hsl(300, 4%, 20%)',
  gray15: 'hsl(300, 4%, 15%)',
  gray10: 'hsl(300, 4.5%, 10%)',
}

export const breakpoints = {
  l: 1440,
  ls: 1260,
  ml: 1080,
  m: 900,
  ms: 720,
  s: 540,
}
